/* eslint-disable react-hooks/exhaustive-deps */
import SearchNotFound from './SearchNotFound';
import SearchList from './List';
import SeachHeader from './Header';
import star from '../../common/images/revamp/icon/star.svg';
import Loader from '../Loader';
import ImageLoader from '../ImageLoader';
import { authHeaders, sendAnalyticsPageView } from '../../utils/helper';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { axiosInstance, sendAnalyticsCustomEvent, sendAnalyticsEvent, trackMetaPixelEvent } from '../../utils/helper';
import { handleGetRecomendation, handleGetPopularSearch } from '../../store/reducers/search';
import { uniqueID } from '../../utils/constants';

const Search = () => {
	console.log('Search');
	const [historySearch, setHistorySearch] = useState([]);
	const dispatch = useDispatch();
	const popular = useSelector((state) => state.search?.popular);
	const recommendation = useSelector((state) => state.search?.recommendation);
	const customerID = useSelector((state) => state.user?.customerID);
	const latitude = useSelector((state) => state.user?.latitude);
	const longitude = useSelector((state) => state.user?.longitude);
  const user = useSelector((state) => state.user);


	const inputRef = useRef(null);
	const [query, setQuery] = useState('');
	const [debounceQuery, setDebounceQuery] = useState(null);
	const [isWaiting, setisWaiting] = useState(false);
	const [outlets, setOutlets] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const [error, setError] = useState('');

	const isValidKeyword = query.trim().length > 0;

	const handleGetProduct = async (value = '') => {
		if (!value) return;
		console.log('handleGetProduct');
		try {
			setIsLoading(true);
			sendAnalyticsEvent('Search Food', 'search_food_fill_query', value);
			sendAnalyticsCustomEvent("homepage_search", { search: value });
			trackMetaPixelEvent("homepage_search", { search: value });

			const url = `store/listStore?unquieid=${uniqueID}&latitude=${latitude}&longitude=${longitude}&keyword=${value}&customerID=${customerID}&company_id=${user?.companyID}`;

			const res = await axiosInstance.get(url, authHeaders());
			if (res?.data?.status === 'ok') {
				setOutlets(res?.data?.result || []);
			} else {
				setOutlets([]);
			}
			if (inputRef.current) {
				inputRef.current.blur();
			}
			setisWaiting(false);
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
      setisWaiting(false);
			setIsLoading(false);
		}
	};

	const handleGetHistorySearch = async () => {
		try {
			const url = `product/history-search?user_id=${customerID}`;
			const res = await axiosInstance.get(url);
			if (res?.data?.status === 'ok') {
				setHistorySearch(res?.data?.data || []);
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleSearch = (value, loading = false) => {
		const trimmed = value.trim();

		setQuery(value);

		if (value === '') {
			setError('');
			setOutlets([]);
			setisWaiting(false);
			setDebounceQuery(null);
			setIsLoading(false);
			return;
		}

		if (!trimmed) {
			setError('Kata kunci pencarian tidak boleh kosong');
			setisWaiting(false);
			return;
		}

		setError('');
		if (loading) setIsLoading(true);
		setisWaiting(true);
	};

	useEffect(() => {
		const handler = setTimeout(() => {
			if (!query || !query.trim()) {
				setDebounceQuery(null);
				return;
			}
			setDebounceQuery(query.trim());
		}, 500);

		return () => {
			clearTimeout(handler);
		};
	}, [query]);

	useEffect(() => {
		if (!debounceQuery) return;
		handleGetProduct(debounceQuery, true);
	}, [debounceQuery]);


	useEffect(() => {
		handleGetHistorySearch();
		dispatch(handleGetPopularSearch());
		handleGetRecomendation();
	}, []);

	useEffect(() => {
		sendAnalyticsPageView("search_food_session");
	}, []);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, []);

	useEffect(() => {
		let height = document.getElementById('history-search-item')?.offsetHeight;
		if (height) document.getElementById('history-search-container').style.height = `${height}px`;
	},);

	useEffect(() => {
		let height = document.getElementById('popular-search-item')?.offsetHeight;
		if (height) document.getElementById('popular-search-container').style.height = `${(height + 12) * 3}px`; // add 12 for additional from gap-3
	});

	return (
		<>
			{isLoading && <Loader overlay />}
			<div className='search'>
				<SeachHeader {...{ query, handleSearch, inputRef }} />

				{error && (
					<p className="px-4 mt-1 text-sm text-red-500">
						{error}
					</p>
				)}

				{!isValidKeyword && (
					<div className='px-4 py-3'>
						{historySearch && historySearch.length > 0 && (
							<div className=''>
								<p className='mb-3 text-[var(--dark-gray)] font-semibold capitalize'>History Search</p>
								<div id='history-search-container' className='flex flex-wrap gap-3 mb-8 overflow-hidden'>
									{historySearch?.map((item, index) => (
										<div
											key={index}
											id='history-search-item'
											className='cursor-pointer rounded-full bg-[var(--rose-violet-opacity)] text-[var(--rose-violet)] px-2.5 py-1.5 font-medium'
											onClick={() => {
												handleSearch(item, true);
											}}>
											{item}
										</div>
									))}
								</div>
							</div>
						)}

						{popular && popular.length > 0 && (
							<div>
								<p className='mb-3 text-[var(--dark-gray)] font-semibold capitalize'>Popular Search</p>
								<div id='popular-search-container'>
									<div className='flex flex-wrap gap-3 mb-8 overflow-hidden'>
										{popular?.map((item, index) => (
											<div
												key={index}
												id='popular-search-item'
												className='cursor-pointer rounded-full bg-[var(--rose-violet-opacity)] text-[var(--rose-violet)] px-2.5 py-1.5 font-medium'
												onClick={() => {
													console.log('onClick', item);
													handleSearch(item, true);
												}}>
												{item}
											</div>
										))}
									</div>
								</div>
							</div>
						)}

						{recommendation && recommendation.length > 0 && (
							<>
								<p className='mb-3 text-[var(--dark-gray)] font-semibold capitalize'>Rekomendasi Restoran Yang Mungkin Anda Suka</p>

								<div className='grid gap-3 grid-cols-3 mb-4'>
									{recommendation?.map((item, index) => (
										<div key={index} className=''>
											<div className='w-32 h-32 p-0.5'>
												<ImageLoader src={item.storeImage} alt={item.storeImage} className='rounded-lg w-full h-full border-1 border-solid border-gray-200 object-center aspect-square' />
											</div>
											<p className='mb-0 font-semibold text-[var(--dark-gray)] max-w-[calc(100vw-139px)] line-clamp-2'>{item.storeName}</p>
											<div className='flex items-center gap-2.5'>
												<div className='flex items-center gap-1'>
													<span>{item.distance !== '' ? parseFloat(item.distance).toFixed('2') : '0'} km</span>
												</div>

												<div className='flex items-center gap-1'>
													<img src={star} alt='star' />
													<span className='font-medium text-sm text-[var(--dark-gray)]'>{item.rating || item.Rating || 0}</span>
												</div>
											</div>
										</div>
									))}
								</div>
							</>
						)}
					</div>
				)}
				{isValidKeyword && !isWaiting ? outlets?.length > 0 ? <SearchList {...{ outlets }} /> : !isLoading ? <SearchNotFound /> : null : null}
			</div>
		</>
	);
};

export default Search;
